module.exports = __webpack_public_path__ + "6dcc6946b999270c78ec4d187f83c5ad.png";